import SearchIcon from '@mui/icons-material/Search';
import {
  InputAdornment,
  TextField,
  type TextFieldProps,
} from '@mui/material';

interface SearchFieldProps extends Omit<TextFieldProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
}

export function SearchField({
  value,
  onChange,
  placeholder,
  size = 'small',
  fullWidth = true,
  ...textFieldProps
}: SearchFieldProps) {
  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      size={size}
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
        ...textFieldProps.InputProps,
      }}
    />
  );
}
